<template>
  <div class="ui grid" v-if="!isGuest">
    <div class="row">
      <h1 class="ui huge header">{{ node ? node.title : 'Resources' }}</h1>
    </div>
    <div class="ui divider"></div>
    <div class="row" v-if="node">
      <div class="sixteen wide column">
        <p v-if="node.blurb">{{ node.blurb }}</p>

        <div class="ui divided relaxed list" v-if="children.length">
          <div class="item" v-for="child in children" :key="child.key">
            <i class="large icon" :class="itemIcon(child)"></i>
            <div class="content">
              <router-link
                v-if="child.to && !child.note"
                :to="child.to"
                class="header"
              >{{ child.title }}</router-link>
              <a
                v-else-if="child.href"
                :href="child.href"
                target="_blank"
                rel="noopener"
                class="header"
              >{{ child.title }}</a>
              <span v-else class="header disabled-item">
                {{ child.title }}
                <span v-if="child.note" class="ui mini label">{{ child.note }}</span>
              </span>
              <div class="description" v-if="child.blurb">{{ child.blurb }}</div>
            </div>
          </div>
        </div>

        <p v-else-if="!node.blurb">No resources have been added here yet.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { findNode } from '@/data/resources';

// Generic page for any node in the Resources tree: shows the node's title / intro and
// links to its children. Reused across every resource route via the router.
export default {
  name: 'ResourcePage',
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    isGuest() {
      return this.user && this.user.profile && this.user.profile.role === 'Guest';
    },
    node() {
      return findNode(this.$route.path);
    },
    children() {
      return (this.node && this.node.children) || [];
    },
  },
  methods: {
    itemIcon(child) {
      if (child.note) {
        return 'grey file outline';
      }
      if (child.to) {
        return 'blue folder';
      }
      const map = {
        word: 'blue file word',
        powerpoint: 'orange file powerpoint',
        video: 'red file video',
      };
      return map[child.fileType] || 'blue file';
    },
  },
  created() {
    this.$store.dispatch('hideLoader');
  },
};
</script>

<style scoped>
.disabled-item {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/resources/ResourcePage.vue